export const PERMISSIONS = {
  ALL: 'all',

  VIEW_DASHBOARD: 'VIEW_DASHBOARD',

  VIEW_PROPERTIES: 'VIEW_PROPERTIES',

  VIEW_ROLE: 'VIEW_ROLE',
  ADD_ROLE: 'ADD_ROLE',
  EDIT_ROLE: 'EDIT_ROLE',
  DELETE_ROLE: 'DELETE_ROLE',
  IMPORT_ROLE: 'IMPORT_ROLE',
  EXPORT_ROLE: 'EXPORT_ROLE',
  ACCEPT_ROLE: 'ACCEPT_ROLE',

  VIEW_USER: 'VIEW_USER',
  ADD_USER: 'ADD_USER',
  EDIT_USER: 'EDIT_USER',
  DELETE_USER: 'DELETE_USER',
  IMPORT_USER: 'IMPORT_USER',
  EXPORT_USER: 'EXPORT_USER',
  ACCEPT_USER: 'ACCEPT_USER',

  VIEW_CUSTOMER: 'VIEW_CUSTOMER',
  ADD_CUSTOMER: 'ADD_CUSTOMER',
  EDIT_CUSTOMER: 'EDIT_CUSTOMER',
  DELETE_CUSTOMER: 'DELETE_CUSTOMER',
  IMPORT_CUSTOMER: 'IMPORT_CUSTOMER',
  EXPORT_CUSTOMER: 'EXPORT_CUSTOMER',
  ACCEPT_CUSTOMER: 'ACCEPT_CUSTOMER',

  VIEW_CATEGORY: 'VIEW_CATEGORY',
  ADD_CATEGORY: 'ADD_CATEGORY',
  EDIT_CATEGORY: 'EDIT_CATEGORY',
  DELETE_CATEGORY: 'DELETE_CATEGORY',
  EXPORT_CATEGORY: 'EXPORT_CATEGORY',
  ACCEPT_CATEGORY: 'ACCEPT_CATEGORY',

  VIEW_PRICE: 'VIEW_PRICE',
  ADD_PRICE: 'ADD_PRICE',
  EDIT_PRICE: 'EDIT_PRICE',
  DELETE_PRICE: 'DELETE_PRICE',
  IMPORT_PRICE: 'IMPORT_PRICE',
  EXPORT_PRICE: 'EXPORT_PRICE',
  ACCEPT_PRICE: 'ACCEPT_PRICE',

  VIEW_APPRAISE: 'VIEW_APPRAISE',
  ADD_APPRAISE: 'ADD_APPRAISE',
  EDIT_APPRAISE: 'EDIT_APPRAISE',
  DELETE_APPRAISE: 'DELETE_APPRAISE',
  IMPORT_APPRAISE: 'IMPORT_APPRAISE',
  EXPORT_APPRAISE: 'EXPORT_APPRAISE',
  ACCEPT_APPRAISE: 'ACCEPT_APPRAISE',

  VIEW_CERTIFICATE: 'VIEW_CERTIFICATE',
  ADD_CERTIFICATE: 'ADD_CERTIFICATE',
  EDIT_CERTIFICATE: 'EDIT_CERTIFICATE',
  DELETE_CERTIFICATE: 'DELETE_CERTIFICATE',
  IMPORT_CERTIFICATE: 'IMPORT_CERTIFICATE',
  EXPORT_CERTIFICATE: 'EXPORT_CERTIFICATE',
  ACCEPT_CERTIFICATE: 'ACCEPT_CERTIFICATE'
}



// WEBPACK FOOTER //
// ./src/enum/permissions.enum.js